import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/hd-basics")({
  head: () => pageHead("Human Design Basics", { canonicalPath: "/hd-basics" }),
});
